export const tenants = {
  DE: {
    country: "Germany",
    language: [
      { key: "DE", value: "de" },
      { key: "EN", value: "en" },
    ],
    default_language: "de",
  },
  AT: {
    country: "Austria",
    language: [
      { key: "DE", value: "de" },
      { key: "EN", value: "en" },
    ],
    default_language: "de",
  },
  NL: {
    country: "Nederland",
    language: [{ key: "NL", value: "nl" }],
    default_language: "nl",
  },
  BE: {
    country: "Belgium",
    language: [
      { key: "FR", value: "fr" },
      { key: "NL", value: "nl" },
      { key: "EN", value: "en" },
      { key: "DE", value: "de" },
      { key: "SK", value: "sk" },
    ],
    default_language: "fr",
  },
  GB: {
    country: "England",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
  FR: {
    country: "France",
    language: [{ key: "FR", value: "fr" }],
    default_language: "fr",
  },
  ES: {
    country: "Spain",
    language: [{ key: "ES", value: "es" }],
    default_language: "es",
  },
  SE: {
    country: "Sweden",
    language: [{ key: "SE", value: "se" }],
    default_language: "se",
  },
  NO: {
    country: "Norge",
    language: [
      { key: "NO", value: "no" },
      { key: "EN", value: "en" },
    ],
    default_language: "no",
  },
  DK: {
    country: "Denmark",
    language: [{ key: "DK", value: "dk" }],
    default_language: "dk",
  },
  CH: {
    country: "Schweiz",
    language: [
      { key: "DE", value: "de" },
      { key: "EN", value: "en" },
      { key: "FR", value: "fr" },
      { key: "IT", value: "it" },
    ],
    default_language: "de",
  },
  IT: {
    country: "Italy",
    language: [{ key: "IT", value: "it" }],
    default_language: "it",
  },
  PL: {
    country: "Polen",
    language: [{ key: "PL", value: "pl" }],
    default_language: "pl",
  },
  HU: {
    country: "Ungarn",
    language: [{ key: "HU", value: "hu" }],
    default_language: "hu",
  },
  HR: {
    country: "Kroation",
    language: [{ key: "HR", value: "hr" }],
    default_language: "hr",
  },
  BG: {
    country: "Bulgaria",
    language: [{ key: "BG", value: "bg" }],
    default_language: "bg",
  },
  RS: {
    country: "Serbien",
    language: [{ key: "RS", value: "rs" }],
    default_language: "rs",
  },
  RO: {
    country: "Romania",
    language: [{ key: "RO", value: "ro" }],
    default_language: "ro",
  },
  CZ: {
    country: "Czech Republic",
    language: [{ key: "CZ", value: "cz" }],
    default_language: "cz",
  },
  SK: {
    country: "Slowakei",
    language: [{ key: "DE", value: "sk" }],
    default_language: "sk",
  },
  MX: {
    country: "Mexiko",
    language: [{ key: "MX", value: "mx" }],
    default_language: "mx",
  },
  US2: {
    country: "Northamerica",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
  LA: {
    country: "Latinamerica",
    language: [{ key: "ES", value: "es" }],
    default_language: "es",
  },
  BR: {
    country: "Brasil",
    language: [{ key: "PT", value: "pt" }],
    default_language: "pt",
  },
  AR: {
    country: "Argentina",
    language: [{ key: "ES", value: "es" }],
    default_language: "es",
  },
  AA: {
    country: "Afrika",
    language: [
      { key: "EN", value: "en" },
      { key: "FR", value: "fr" },
    ],
    default_language: "en",
  },
  ZA: {
    country: "South Africa",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
  TR: {
    country: "Türkei",
    language: [{ key: "TR", value: "tr" }],
    default_language: "tr",
  },
  AE: {
    country: "Middle East",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
  IN: {
    country: "India",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
  AU: {
    country: "Australia",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
  CN: {
    country: "China",
    language: [{ key: "CN", value: "cn" }],
    default_language: "cn",
  },
  SC: {
    country: "System Configurator",
    language: [
      { key: "DE", value: "de" },
      { key: "EN", value: "en" },
      { key: "NO", value: "no" },
      { key: "SE", value: "se" },
      { key: "DK", value: "dk" },
      { key: "NL", value: "nl" },
      { key: "FR", value: "fr" },
      { key: "SK", value: "sk" },
      { key: "ES", value: "es" },
      { key: "IT", value: "it" },
    ],
    default_language: "de",
  },
  SAME_DEFAULT: {
    country: "Same Proj",
    language: [{ key: "EN", value: "en" }],
    default_language: "en",
  },
};
